import './styles.css';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function WhatsApp({ config }) {
    return (
        <a href={`https://wa.me/${config.number}`} target="_blank" className='whatsapp-button'>
            {
                config.avatar && <img src={config.avatar} alt="WhatsApp" className='whatsapp-avatar' />
            }
            <p>{config.text}</p>
            <WhatsAppIcon />
        </a>
    )
}